"use client";

import { FC, useCallback, useState } from "react";
import { useRouter } from "next/navigation";
import { handleRedirection } from "../../utils/helper";
import { PayLaterMtfContent } from "./PayLaterMtfContent";
import { PayLaterMtfStockItem } from "./PayLatermtfTypes";

interface PayLaterMtfCardProps {
  stock: PayLaterMtfStockItem;
  defaultImage?: string;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
  payOnly?: string;
  onCardClick?: (stock: PayLaterMtfStockItem) => void;
}

export const PayLaterMtfCard: FC<PayLaterMtfCardProps> = ({
  stock,
  defaultImage,
  modalTitle,
  modalBtnCta,
  successMsg,
  errorMsg,
  payOnly,
  onCardClick,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const router = useRouter();

  const handleCardClick = useCallback(
    (e: React.MouseEvent) => {
      if (isModalOpen) {
        return;
      }

      const target = e.target as HTMLElement;
      if (
        target.closest('button[aria-label="Add to watchlist"]') ||
        target.closest(".icomoon")
      ) {
        return;
      }
      onCardClick?.(stock);
      handleRedirection(`/${stock.redirectURL}`, router);
    },
    [onCardClick, stock, isModalOpen, router],
  );

  return (
    <button
      type="button"
      onClick={handleCardClick}
      className="w-[156px] max-w-[156px] shrink-0 border-0 bg-transparent p-0 text-left md:w-[215px] md:max-w-[215px]"
      aria-label={`View details for ${stock.fullName || stock.symbol || "stock"}`}
    >
      <div className="flex w-full min-w-0 flex-col overflow-hidden">
        <div className="box-border flex min-h-[143px] w-full shrink-0 items-start justify-start rounded-t-[8px] border border-b-0 border-[#e5e5e5] bg-white p-3 md:min-h-[171px]">
          <div className="min-w-0 w-full">
            <div className="flex min-w-0 flex-col">
              <PayLaterMtfContent
                stock={stock}
                defaultImage={defaultImage}
                onModalStateChange={setIsModalOpen}
                modalTitle={modalTitle}
                modalBtnCta={modalBtnCta}
                successMsg={successMsg}
                errorMsg={errorMsg}
              />
            </div>
          </div>
        </div>

        <div className="box-border flex w-full shrink-0 items-center gap-2 overflow-hidden rounded-b-[4px] border border-[#e5e5e5] bg-[#D1E2FB80] px-3 py-[4px] md:py-[8px]">
          <span className="flex h-3 w-3 shrink-0 items-center justify-center rounded-full bg-[#1056AA] text-[10px] font-medium leading-none text-white md:h-4 md:w-4">
            %
          </span>
          <span className="min-w-0 truncate text-[12px] font-Regular text-[#1056AA] md:text-[14px]">
           { payOnly ?? `Pay Only`} {stock.perFunding}%
          </span>
        </div>
      </div>
    </button>
  );
};

export default PayLaterMtfCard;
